import DashboardIcon from '@/components/svg/sidebar-icons/DashboardIcon';
import DataAcquisitionIcon from '@/components/svg/sidebar-icons/DataAcquisitionIcon';
import EnergyAuditIcon from '@/components/svg/sidebar-icons/EnergyAuditIcon';
import HesIcon from '@/components/svg/sidebar-icons/HesIcon';
import NfmsIcon from '@/components/svg/sidebar-icons/NfmsIcon';
import PrepaidEngineIcon from '@/components/svg/sidebar-icons/PrepaidEngineIcon';
import ReportIcon from '@/components/svg/sidebar-icons/ReportIcon';
import SatIcon from '@/components/svg/sidebar-icons/SatIcon';
import SchedulingIcon from '@/components/svg/sidebar-icons/SchedulingIcon';
import VeeIcon from '@/components/svg/sidebar-icons/VeeIcon';

export const sidebarIconsUrlData = [
  DashboardIcon,
  SchedulingIcon,
  DataAcquisitionIcon,
  VeeIcon,
  EnergyAuditIcon,
  ReportIcon,
  HesIcon,
  NfmsIcon,
  SatIcon,
  PrepaidEngineIcon,
  EnergyAuditIcon,
  DataAcquisitionIcon
];

export const sidebarLinkData = [
  { to: '/dashboard/', title: 'Dashboard' },
  { to: '/scheduling/', title: 'Scheduling' },
  { to: '/data-acquisition/', title: 'Data Acquisition' },
  { to: '/vee/', title: 'VEE' },
  { to: '/energy-accounting/', title: 'Energy Accounting' },
  { to: '/reports/', title: 'Reports' },
  { to: '/hes', title: 'HES', isNative: true },
  { to: '/nfms', title: 'NFMS' },
  { to: '/sat', title: 'SAT' },
  { to: '/prepaid-engine', title: 'Prepaid Engine' },
  { to: '/nms', title: 'NMS' },
  { to: '/report', title: 'Report' }
];

export const moduleNameMapping = new Map<string, string>([
  ['hes', 'Head End System (HES)'],
  ['sat', 'Site Acceptance Test (SAT)'],
  ['validation', 'Validation Estimation & Editing (VEE)'],
  ['scheduling', 'Scheduling'],
  ['data-acquisition', 'Data Acquisition'],
  ['nfms', 'National Feeder Monitoring System (NFMS)'],
  ['mdms', 'Meter Data Management System (MDMS)'],
  ['dashboard', 'Dashboard'],
  ['scheduling', 'Scheduling'],
  ['energy-audit', 'Energy Audit'],
  ['reports', 'Reports'],
  ['prepaid-engine', 'Prepaid Engine']
]);

export const sidebarItemsArray = ['hes', 'nfms', 'prepaid-engine'];

export type NavBarItem = {
  to: string;
  title: string;
  children?: NavBarItem[];
};

export type NavbarDataType = Map<string, NavBarItem[]>;

const hesNavbarData: NavBarItem[] = [
  { to: '/hes', title: 'Dashboard' },
  // { to: '/hes/scheduled-reads', title: 'Scheduled Reads' },
  {
    to: '/hes/meter-profile-data',
    title: 'Meter Profile Data',
    children: [
      { to: '/hes/meter-profile-data/block-load', title: 'Block Load' },
      { to: '/hes/meter-profile-data/daily-load', title: 'Daily Load' },
      {
        to: '/hes/meter-profile-data/monthly-billing',
        title: 'Monthly Billing'
      },
      {
        to: '/hes/meter-profile-data/instantaneous-profile',
        title: 'Instantaneous Profile'
      },
      { to: '/hes/meter-profile-data/periodic-push', title: 'Periodic Push' },
      {
        to: '/hes/meter-profile-data/name-plate-detail',
        title: 'Name Plate Detail'
      },
      ...(import.meta.env.VITE_PROJECT_NAME === 'sangai'
        ? [{ to: '/hes/meter-profile-data/tod', title: 'TOD' }]
        : [])
    ]
  },
  {
    to: '/hes/command',
    title: 'Command',
    children: [
      { to: '/hes/command/command-execution', title: 'Command Execution' },
      {
        to: '/hes/command/command-execution-history',
        title: 'Execution History'
      }
    ]
  },
  {
    to: '/hes/alarms', // folder name as push events
    title: 'Alarms'
  },
  {
    to: '/hes/events', // folder name as pull-events
    title: 'Events',
    children: [
      {
        to: '/hes/events/voltage-events',
        title: 'Voltage Events'
      },
      {
        to: '/hes/events/current-events',
        title: 'Current Events'
      },
      {
        to: '/hes/events/power-related-events',
        title: 'Power Related Events'
      },
      {
        to: '/hes/events/non-roll-over-events',
        title: 'Non Roll Over Events'
      },
      {
        to: '/hes/events/control-events',
        title: 'Control Events'
      },
      {
        to: '/hes/events/other-events',
        title: 'Other Events'
      },
      {
        to: '/hes/events/transactional-events',
        title: 'Transactional Events'
      }
    ]
  },
  { to: '/hes/device-information', title: 'Device Information' },
  { to: '/hes/meter-statistics', title: 'Meter Statistics' },
  { to: '/hes/configure-command', title: 'Configure Command ' },
  { to: '/hes/meter-relay-status', title: 'Meter Relay Status' },
  { to: '/hes/realtime-clock', title: 'Real Time Clock' }
];

//add legacy rf rf upgrade screen if env is present
if (import.meta.env.VITE_LEGACY_RF_FW_UPGRADE_BASE_URL) {
  hesNavbarData.push({
    to: '/hes/rf-firmware-upgrade',
    title: 'RF FW Upgrade'
  });
}
if (import.meta.env.VITE_LEGACY_DCU_FW_UPGRADE_BASE_URL) {
  hesNavbarData.push({
    to: '/hes/dcu-firmware-upgrade',
    title: 'DCU FW Upgrade'
  });
}

const nfmsNavbarData: NavBarItem[] = [
  { to: '/nfms/feeder-master-data', title: 'Feeder Master Data' },
  { to: '/nfms/block-load-sync', title: 'Block Load Sync' },
  { to: '/nfms/realtime-alarms-sync', title: 'Realtime Alarms Sync' },
  {
    to: '/nfms/logs',
    title: 'Logs',
    children: [
      { to: '/nfms/logs/success-logs', title: 'Success Logs' },
      { to: '/nfms/logs/failed-logs', title: 'Failed Logs' }
    ]
  }
];

const prepaidEngineData: NavBarItem[] = [
  { to: '/prepaid-engine', title: 'Dashboard' },
  {
    to: '/prepaid-engine/tariff-configuration',
    title: 'Tariff Configuration'
  },
  {
    to: '/prepaid-engine/feature-access-panel',
    title: 'Feature Access Panel'
  },
  { to: '/prepaid-engine/arrear-configuration', title: 'Arrear Configuration' },
  { to: '/prepaid-engine/fppas', title: 'FPPAS' }
];

export const navbarData: NavbarDataType = new Map([
  ['hes', hesNavbarData],
  ['nfms', nfmsNavbarData],
  ['prepaid-engine', prepaidEngineData]
]);

const blockLoadOriginalCols = [
  'block_consumed_reactive_energy_Q1_kVArh',
  'block_consumed_export_kVAh',
  'block_consumed_export_kWh',
  'block_consumed_import_kVAh',
  'block_consumed_import_kWh',
  'block_consumed_reactive_energy_Q1_kVArh',
  'block_consumed_reactive_energy_Q2_kVArh',
  'block_consumed_reactive_energy_Q3_kVArh',
  'block_consumed_reactive_energy_Q4_kVArh',
  'Block energy, kVAh (Export)',
  'Block energy, kVAh (Import)',
  'Block energy, kWh (Export)',
  'Block energy, kWh (Import)'
];
const dailyLoadOriginalCols = [
  'cumm_energy_export_kVAh',
  'cumm_energy_export_kWh',
  'cumm_energy_import_kVAh',
  'cumm_energy_import_kWh',
  'cumm_energy_kVArh_Q1',
  'cumm_energy_kVArh_Q2',
  'cumm_energy_kVArh_Q3',
  'cumm_energy_kVArh_Q4',
  'Cumulative energy, kVAh (Export)',
  'Cumulative energy, kVAh (Import)',
  'Cumulative energy, kWh (Export)',
  'Cumulative energy, kWh (Import)'
];

const commonFields = [
  'Cumulative energy, kWh (Export)',
  'Cumulative energy, kVAh (Export)',
  'Cumulative energy, kVAh (Import)',
  'Cumulative energy, kWh (Import)',
  'Cumulative energy, kvarh-Q1',
  'Cumulative energy, kvarh-Q2',
  'Cumulative energy, kvarh-Q3',
  'Cumulative energy, kvarh-Q4',
  'Block energy, kWh (Export)',
  'Block energy, kWh (Import)',
  'Block energy, kVAh (Export)',
  'Block energy, kVAh (Import)',
  'Average current',
  'Average voltage',
  'Voltage, VBN / VBY',
  'Voltage, VRN / VRY',
  'Voltage, VYN',
  'Current, IB',
  'Current, IR',
  'Current, IY',
  'Block energy, kvarh-Q1',
  'Block energy, kvarh-Q2',
  'Block energy, kvarh-Q3',
  'Block energy, kvarh-Q4',
  'Cumulative energy, kWh for TZ1',
  'Cumulative energy, kWh for TZ2',
  'Cumulative energy, kWh for TZ3',
  'Cumulative energy, kWh for TZ4',
  'Cumulative energy, kWh for TZ5',
  'Cumulative energy, kWh for TZ6',
  'Cumulative energy, kWh for TZ7',
  'Cumulative energy, kWh for TZ8',
  'Cumulative energy, kVAh for TZ1',
  'Cumulative energy, kVAh for TZ2',
  'Cumulative energy, kVAh for TZ3',
  'Cumulative energy, kVAh for TZ4',
  'Cumulative energy, kVAh for TZ5',
  'Cumulative energy, kVAh for TZ6',
  'Cumulative energy, kVAh for TZ7',
  'Cumulative energy, kVAh for TZ8',
  'MD, kW',
  'MD_kW_datetime',
  'MD, kW for TZ1',
  'MD_kW_TOD_1_datetime',
  'MD, kW for TZ2',
  'MD_kW_TOD_2_datetime',
  'MD, kW for TZ3',
  'MD_kW_TOD_3_datetime',
  'MD, kW for TZ4',
  'MD_kW_TOD_4_datetime',
  'MD, kW for TZ5',
  'MD_kW_TOD_5_datetime',
  'MD, kW for TZ6',
  'MD_kW_TOD_6_datetime',
  'MD, kW for TZ7',
  'MD_kW_TOD_7_datetime',
  'MD, kW for TZ8',
  'MD_kW_TOD_8_datetime',
  'MD, kVA',
  'MD_kVA_datetime',
  'MD, kVA for TZ1',
  'MD_kVA_TOD_1_datetime',
  'MD, kVA for TZ2',
  'MD_kVA_TOD_2_datetime',
  'MD, kVA for TZ3',
  'MD_kVA_TOD_3_datetime',
  'MD, kVA for TZ4',
  'MD_kVA_TOD_4_datetime',
  'MD, kVA for TZ5',
  'MD_kVA_TOD_5_datetime',
  'MD, kVA for TZ6',
  'MD_kVA_TOD_6_datetime',
  'MD, kVA for TZ7',
  'MD_kVA_TOD_7_datetime',
  'MD, kVA for TZ8',
  'MD_kVA_TOD_8_datetime',
  'Current, IR',
  'Current, IY',
  'Current, IB',
  'Voltage, VRN/VRY',
  'Voltage, VYN',
  'Voltage, VBN / VBY',
  'Apparent power, kVA',
  'Signed active power, kW (+ Forward; - Reverse)',
  'Signed reactive power, kvar (+ Lag; - Lead)',
  'Voltage',
  'Current, Ip',
  'Current, In',
  'Real time clock, date, and time',
  'Signed power factor',
  'Cumulative tamper count',
  'Cumulative billing count',
  'Cumulative programming count',
  'Frequency, Hz',
  'Device ID',
  'Firmware version for meter',
  'Manufacturer name',
  'Meter type',
  'Category',
  'Current rating',
  'Meter year of manufacture',
  'Event code',
  'export_kVAh',
  'export_kWh',
  'import_kVAh',
  'import_kWh'
];

const monthlyBillingOriginalCols = [
  'MD_kVA',
  'MD_kVA_TOD_1',
  'MD_kVA_TOD_1_datetime',
  'MD_kVA_TOD_2',
  'MD_kVA_TOD_2_datetime',
  'MD_kVA_TOD_3',
  'MD_kVA_TOD_3_datetime',
  'MD_kVA_datetime',
  'MD_kVA_export',
  'MD_kVA_export_TZ1',
  'MD_kVA_export_TZ1_datetime',
  'MD_kVA_export_TZ2',
  'MD_kVA_export_TZ2_datetime',
  'MD_kVA_export_TZ3',
  'MD_kVA_export_TZ3_datetime',
  'MD_kW',
  'MD_kW_TOD_1',
  'MD_kW_TOD_1_datetime',
  'MD_kW_TOD_2',
  'MD_kW_TOD_2_datetime',
  'MD_kW_TOD_3',
  'MD_kW_TOD_3_datetime',
  'MD_kW_datetime',
  'MD_kW_export',
  'MD_kW_export_TZ1',
  'MD_kW_export_TZ1_datetime',
  'MD_kW_export_TZ2',
  'MD_kW_export_TZ2_datetime',
  'MD_kW_export_TZ3',
  'MD_kW_export_TZ3_datetime',
  'MD_kW_export_datetime',
  'cumm_energy_export_kVAh',
  'cumm_energy_export_kWh',
  'cumm_energy_import_kVAh',
  'cumm_energy_import_kWh',
  'cumm_energy_kVArh_Q1',
  'cumm_energy_kVArh_Q2',
  'cumm_energy_kVArh_Q3',
  'cumm_energy_kVArh_Q4',
  'import_kVAh_TOD_1',
  'import_kVAh_TOD_2',
  'import_kVAh_TOD_3',
  'import_kVAh_TOD_4',
  'import_kVAh_TOD_5',
  'import_kVAh_TOD_6',
  'import_kVAh_TOD_7',
  'import_kVAh_TOD_8',
  'import_kWh_TOD_1',
  'import_kWh_TOD_2',
  'import_kWh_TOD_3',
  'import_kWh_TOD_4',
  'import_kWh_TOD_5',
  'import_kWh_TOD_6',
  'import_kWh_TOD_7',
  'import_kWh_TOD_8',
  'kVAh_export_TZ1',
  'kVAh_export_TZ2',
  'kVAh_export_TZ3',
  'kWh_export_TZ1',
  'kWh_export_TZ2',
  'kWh_export_TZ3',
  'kWh_export_TZ4',
  'kWh_export_TZ5',
  'kWh_export_TZ6',
  'kWh_export_TZ7',
  'kWh_export_TZ8',
  'kVAh_export_TZ4',
  'kVAh_export_TZ5',
  'kVAh_export_TZ6',
  'kVAh_export_TZ7',
  'kVAh_export_TZ8',
  'billing_datetime'
];

const profileInstantOriginalCols = ['signed_reactive_power_KVAR'];

export const originalCols = [
  ...blockLoadOriginalCols,
  ...dailyLoadOriginalCols,
  ...monthlyBillingOriginalCols,
  ...profileInstantOriginalCols,
  ...commonFields
];

export const colorPalette = [
  '#0A3690',
  '#46a2e5',
  '#92FE9D',
  '#FF4242',
  '#4d9dd8',
  '#73c4fe',
  '#FA1919',
  '#FF9F2E',
  '#5fbbcb',
  '#FFC32E',
  '#2cbbcb',
  '#FF7272',
  '#5fbbfe',
  '#87cc98',
  '#27c4b2',
  '#ABC7FF',
  '#279db2',
  '#81e4d4',
  '#02C9A8',
  '#b6c3de',
  '#3C63FF',
  '#46a2cb',
  '#FF5A5A',
  '#219998',
  '#37AAFE',
  '#C7EFE8',
  '#2F80ED',
  '#4ed9c2',
  '#3b5ea6',
  '#09B6A8',
  '#D7EDF0',
  '#5472b1',
  '#2ca2cb',
  '#AEE3EA',
  '#11ABBE',
  '#39548a',
  '#00C9FF',
  '#37AAFF',
  '#859bc8',
  '#73c4b2',
  '#4d9db2',
  '#22458d',
  '#35d4b9',
  '#9dafd3'
];

export const cardColorPalette = ['#00C4B4', '#2F80ED', '#0A3690', '#3B68FF'];
